import { userAvatar } from 'Services/avatarGenerator'

/**
 * @param {ApiCompanyFaqAnswer | null} answer
 */
export const parseAnswer = (answer) => {
  if (!answer) {
    return {
      author: {
        name: null,
        avatar: userAvatar(null, 'Usuário'),
        url: null,
      },
      question: null,
      answer: null,
      url: null,
      asked: null,
      answered: null,
    }
  }

  const info = {
    question: answer.questionTitle ?? '',
    answer: answer.answerDescription ?? '',
    url: answer.questionUrl ?? null,
    asked: answer.questionDateCreated
      ? `há ${answer.questionDateCreated}`
      : null,
    answered: answer.answerDateCreated
      ? `há ${answer.answerDateCreated}`
      : null,
  }

  const author = {
    name: answer.authorName ?? 'Anônimo',
    avatar: userAvatar(answer.authorImageUrl ?? null, answer.authorName ?? 'Anônimo'),
    url: null,
  }

  return { author, ...info }
}

/**
 * @param {ApiCompanyFaqQuestion | null} data
 */
export const parseAnswerList = (data) => {
  const answers = Array.isArray(data?.answers) ? data.answers : []
  return answers
    .filter((a) => a != null)
    .map(parseAnswer)
}

export default {
  parseAnswer,
  parseAnswerList,
}
